// extracted by mini-css-extract-plugin
module.exports = {"root":"📦AssetImages__root--3mmK_","carouselContainer":"📦AssetImages__carouselContainer--3YQ2x"};